import React from "react";

function BS4_Forms() {
  return (
    <div>
      <h1>BS4_Forms Component</h1>
      <p>This is the BS4_Forms tutorial page content.</p>
    </div>
  );
}

export default BS4_Forms;
